<app-header [layout]="LogoutHeader" *ngIf="!isLoggedIn"></app-header>
<div class="network-status-container">
    <!-- Static Left Card -->
    <!-- <div class="left-card">
        <div class="card-header">
            <h2>Network Status</h2>
        </div>
        <p class="description">Here you can see the status updates of our Fibre Networks</p>

        <div class="notification-section">
            <h3>Get Notified on your Mobile Phone</h3>
            <div class="notification-icon my-5">
                <i class="fas fa-bell"></i>
                <span class="badge">4</span>
            </div>
            <p class="notification-text mx-4">Simply download the Home-Connect Mobile App and we'll conveniently send
                you push notifications to your mobile phone</p>
            <button class="btn-app">
                <a href="https://www.home-connect.co.za/mobile-app/" target="_blank" style="color: white;">
                    <i class="fas fa-download"></i> GET THE APP
                </a>
            </button>
        </div>
    </div> -->

    <!-- Scrollable Right Card -->
    <div class="right-card">
        <div class="card-header">
            <h2>Network Status for {{ currentDate }}</h2>
        </div>

        <div class="status-list">
            <!-- Loop through network statuses -->
            <div class="status-item" *ngFor="let status of networkStatuses">
                <div class="status-header">
                    <h4>{{ status.subject }}</h4>
                    <span class="status-badge update">Update</span>
                </div>
                <p class="status-time">{{ status.creationTs }}</p>
                <p class="status-message">
                    {{ status.message }}
                </p>
            </div>
        </div>
    </div>
</div>